import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { SmartLink, Flex, CheckmarkIllustration, PrimaryButton } from '@stashinvest/ui';
import { Text } from '@stashinvest/react-components';
import { BanjoString } from '@stashinvest/react-banjo';
import ACCOUNT_SUBTYPE from 'stash/constants/accountSubtypes';
import { v1_ExternalAccountLinkSetupResults_ViewedProperties } from '@stashinvest/product-events-javascript/lib/v1/properties';
import { trackOnSetupResults } from './LinkPlaidEvents';

const LinkPlaidSuccess = ({
	accountName,
	accountType,
	maskedNumber,
	successPath,
	trackEvent,
	isOnboarding,
}) => {
	useEffect(() => {
		if (!trackEvent) return;
		trackOnSetupResults(
			isOnboarding,
			trackEvent,
			v1_ExternalAccountLinkSetupResults_ViewedProperties.Result.success
		);
	}, [trackEvent, isOnboarding]);

	return (
		<>
			<Flex alignItems="center" justifyContent="center" flexDirection="column">
				<CheckmarkIllustration mb="m" />
				<Text textStyle="headerSmall" textAlign="center" className="mb-contentSmall">
					{accountType === ACCOUNT_SUBTYPE.SAVINGS ? (
						<BanjoString stringId="information/alert/savingsAccountLinked" />
					) : (
						<BanjoString stringId="information/alert/checkingAccountLinked" />
					)}
				</Text>
				<Text
					textStyle="bodyMediumStandard"
					textAlign="center"
					className="mb-contentSmall"
				>
					You&apos;ll be able to use {accountName} {maskedNumber} to add cash and invest.
				</Text>
				<Flex
					width="100%"
					justifyContent="center"
					className="my-contentMedium px-contentXS"
				>
					<PrimaryButton as={SmartLink} to={successPath} onClick={() => null}>
						<BanjoString stringId="action/progress/nextScreen" />
					</PrimaryButton>
				</Flex>
			</Flex>
		</>
	);
};

LinkPlaidSuccess.defaultProps = {
	successPath: '/',
};

LinkPlaidSuccess.propTypes = {
	accountName: PropTypes.string.isRequired,
	accountType: PropTypes.string.isRequired,
	maskedNumber: PropTypes.string.isRequired,
	successPath: PropTypes.string,
	trackEvent: PropTypes.func,
	isOnboarding: PropTypes.bool,
};

export default LinkPlaidSuccess;
